import { createReducer, on } from '@ngrx/store';

import { IFilter, IFilterNumber } from '@shared/models/graphql';
import { IFilterProForma, IPropertiesFilters } from '@shared/models/filters';

import {
  resetFiltersAction,
  resetUnsavedFiltersAction,
  setFiltersAction,
  setUnsavedCBSAsFiltersAction,
  setUnsavedStatusFiltersAction,
  setUnsavedIsVerifiedFiltersAction,
  setUnsavedPriceFiltersAction,
  setUnsavedProFormaFiltersAction,
  setUnsavedBedroomsFiltersAction,
  setUnsavedBathroomsFiltersAction,
  setUnsavedSubtypeFiltersAction,
  setUnsavedSquareFootFiltersAction,
  setUnsavedLotSizeFiltersAction,
  setUnsavedYearBuiltFiltersAction,
} from './filters.actions';
import { TPropertySubType } from '@shared/models/properties';

export interface FiltersState {
  current?: IPropertiesFilters;
  unsaved?: IPropertiesFilters;
}

export const initialState: FiltersState = {
  current: {
    CBSAs: undefined,
    status: { in: ['OPEN'] },
    isVerified: undefined,
    price: undefined,
    proForma: undefined,
    bedrooms: undefined,
    bathrooms: undefined,
    subType: undefined,
    squareFoot: undefined,
    lotSize: undefined,
    yearBuilt: undefined,
  },
  unsaved: {
    CBSAs: undefined,
    status: undefined,
    isVerified: undefined,
    price: undefined,
    proForma: undefined,
    bedrooms: undefined,
    bathrooms: undefined,
    subType: undefined,
    squareFoot: undefined,
    lotSize: undefined,
    yearBuilt: undefined,
  },
};

export const filtersReducer = createReducer(
  initialState,
  on(resetFiltersAction, (state) => ({
    ...initialState,
    current: {
      ...initialState.current,
    },
    unsaved: {
      ...initialState.unsaved,
    },
  })),
  on(resetUnsavedFiltersAction, (state) => ({
    ...state,
    unsaved: { ...state.current },
  })),
  on(setFiltersAction, (state) => ({
    ...state,
    current: { ...state.unsaved },
  })),
  on(setUnsavedCBSAsFiltersAction, (state, action) => ({
    ...state,
    unsaved: {
      ...state.unsaved,
      CBSAs: action.items && action.items.length > 0 ? action.items : undefined,
    },
  })),
  on(setUnsavedStatusFiltersAction, (state, action) => ({
    ...state,
    unsaved: {
      ...state.unsaved,
      status: action.in ? { in: [...action.in] } : undefined,
    },
  })),
  on(setUnsavedIsVerifiedFiltersAction, (state, action) => ({
    ...state,
    unsaved: {
      ...state.unsaved,
      isVerified: action.eq ? { eq: action.eq } : { eq: false },
    },
  })),
  on(setUnsavedPriceFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, price: { ...query } },
    };
  }),
  on(setUnsavedProFormaFiltersAction, (state, action) => {
    const query: IFilterProForma & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, proForma: { ...query } },
    };
  }),
  on(setUnsavedBedroomsFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, bedrooms: { ...query } },
    };
  }),
  on(setUnsavedBathroomsFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, bathrooms: { ...query } },
    };
  }),
  on(setUnsavedSubtypeFiltersAction, (state, action) => {
    const query: IFilter<TPropertySubType> & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, subType: { ...query } },
    };
  }),
  on(setUnsavedSquareFootFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, squareFoot: { ...query } },
    };
  }),
  on(setUnsavedLotSizeFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, lotSize: { ...query } },
    };
  }),
  on(setUnsavedYearBuiltFiltersAction, (state, action) => {
    const query: IFilterNumber & { type?: string } = { ...action };
    delete query.type;
    return {
      ...state,
      unsaved: { ...state.unsaved, yearBuilt: { ...query } },
    };
  })
);
